import { isError } from "util";

import { app } from "@microsoft/teams-js";
import { TeamsSurveyResponse } from "@teams/types";
import { IntegrationDTO, SurveyResponsesDTO } from "@teams/types/api";
import { useCallback, useState } from "react";

import { surveyApi } from "../../_shared/services/SurveyApi";

export const useSurveyResponses = () => {
  const [isResponsesLoading, setIsResponsesLoading] = useState<boolean>(true);
  const [responses, setResponses] = useState<TeamsSurveyResponse[]>();
  const [results, setResults] = useState<SurveyResponsesDTO>();
  const [autolinkIntegrations, setAutolinkIntegrations] = useState<IntegrationDTO[]>();
  const [responsesError, setResponsesError] = useState<Error>();

  const loadSurveyResponses = useCallback(async (context: app.Context, surveyId: string) => {
    setIsResponsesLoading(true);
    const result = await surveyApi.surveyResponses(context, surveyId);
    if (isError(result)) {
      setResponsesError(result);
    } else {
      setResults(result);
      setResponses(result.responses);
      setAutolinkIntegrations(result.autolinkIntegrations);
    }
    setIsResponsesLoading(false);
  }, []);

  return {
    loadSurveyResponses,
    isResponsesLoading,
    responses,
    results,
    autolinkIntegrations,
    responsesError,
  };
};
